import React from "react";
import { Routes, Route } from "react-router-dom";
import TopSelling from "./pages/top-selling.jsx";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<TopSelling />} />
      <Route path="/top-selling" element={<TopSelling />} />
      {/* fallback for anything else */}
      <Route path="*" element={<TopSelling />} />
    </Routes>
  );
}

